import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import swal from 'sweetalert2';
// import { environment } from '@ov-suite/helpers-shared';
import { AuthenticationService } from '@ov-suite/authguard-angular/lib/authentication/authentication.service';

@Component({
  selector: 'ov-suite-login-cmp',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class JwtLoginComponent implements OnInit, OnDestroy {
  focus;

  focus1;

  test: Date = new Date();

  private readonly toggleButton;

  private readonly sidebarVisible: boolean;

  private readonly nativeElement: Node;

  authState: string;

  username = '';

  password = '';

  firstName: string;

  lastName: string;

  phoneNumber: string;

  newPassword: string;

  confirmPassword: string;

  requiredResponse = [];

  loading: boolean;

  errorMessage: string;

  forgotPassword: boolean;

  verificationCode: string;

  passwordsMatch: boolean;

  passwordVisible = false;

  // federated = !!environment.cognito.oauth.domain;

  // federatedText = environment.cognito.federatedButtonText ?? 'Sign In';

  // passwordPolicyText = environment.cognito.passwordPolicyText;

  constructor(
    private readonly element: ElementRef,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authenticationService: AuthenticationService,
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');

    this.forgotPassword = false;
    this.passwordsMatch = false;
    this.loading = false;

    this.authenticationService.user.subscribe(user => {
      if (user) {
        if (user.resetPassword) {
          this.authState = 'NEW_PASSWORD_REQUIRED';
          return;
        }
        this.navigateToRedirect();
      }
    });
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
  }

  async signIn() {
    this.trimInput();
    this.loading = true;
    if (this.forgotPassword) {
      this.forgottenPasswordSignIn();
    } else {
      this.authenticateUser();
    }
  }

  async federatedSignIn() {
    // await Auth.federatedSignIn();
  }

  forgotPasswordClick() {
    this.forgotPassword = true;
    this.authenticationService
      .forgotPassword(this.username.trim())
      .then(() => {
        swal.fire({
          title: 'Success',
          text: `An email has been sent to the email of that account`,
          showConfirmButton: true,
          type: 'success',
        });
        this.forgotPassword = false;
      })
      .catch(() => {
        swal.fire({
          title: 'Something went wrong. Please try again later',
          showConfirmButton: true,
          type: 'error',
        });
      });
    // Auth.forgotPassword(this.user.email)
    //   .then(response => {
    //     swal.fire({
    //       title: 'A Verification Code has been sent.',
    //       text: `${response.CodeDeliveryDetails.DeliveryMedium} sent to ${response.CodeDeliveryDetails.Destination}`,
    //       showConfirmButton: true,
    //       type: 'success',
    //     });
    //   })
    //   .catch(() => {
    //     swal.fire({
    //       title: 'Code not sent. Please try again after some time.',
    //       showConfirmButton: true,
    //       type: 'warning',
    //     });
    //   });
  }

  async authenticateUser() {
    this.authenticationService
      .login(this.username.trim(), this.password.trim())
      .then(() => {
        // setTimeout(() => this.navigateToRedirect(), 2000);
      })
      .catch(() => {
        swal.fire({
          title: 'Incorrect Username or password',
          timer: 2000,
          showConfirmButton: false,
          type: 'warning',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  forgottenPasswordSignIn() {
    if (!!this.newPassword && this.newPassword.length > 0 && this.passwordsMatch) {
      // Auth.forgotPasswordSubmit(this.user.email, this.verificationCode, this.newPassword)
      //   .then(() => {
      //     return Auth.signIn(this.user.email, this.newPassword);
      //   })
      //   .then(user => {
      //     this.setAuthTokenAndNavigate(user);
      //   })
      //   .catch(e => {
      //     swal.fire({
      //       title: 'Did not change Password.',
      //       text: e?.message,
      //       showConfirmButton: true,
      //       type: 'warning',
      //     });
      //     this.loading = false;
      //   });
    }
  }

  trimInput() {
    // Object.keys(this.username).forEach(key => {
    //   if (this.user[key]) {
    //     this.user[key] = this.user[key].trim();
    //   }
    // });
  }

  confirmPasswordsMatch() {
    this.passwordsMatch = this.newPassword === this.confirmPassword;
  }

  setAuthTokenAndNavigate(user) {
    if (user.signInUserSession) {
      this.navigateToRedirect();
    }
    this.loading = false;
  }

  navigateToRedirect() {
    this.route.params
      .subscribe(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const url = urlParams.get('redirect');
        if (url) {
          window.location.assign(url);
        } else {
          this.router.navigate(['/dashboard']).then(() => {
            this.loading = false;
          });
        }
      })
      .unsubscribe();
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  setNewPassword() {
    if (this.newPassword !== this.confirmPassword) {
      swal.fire({
        title: 'Passwords do not match',
        timer: 2000,
        showConfirmButton: false,
        type: 'warning',
      });
      return;
    }

    if (!this.newPassword.match(/\d/)) {
      swal.fire({
        title: 'Password must include a number',
        timer: 2000,
        showConfirmButton: false,
        type: 'warning',
      });
      return;
    }

    if (!this.newPassword.match(/[A-Z]/)) {
      swal.fire({
        title: 'Password must include a capital letter',
        timer: 2000,
        showConfirmButton: false,
        type: 'warning',
      });
      return;
    }

    if (!this.newPassword.match(/[a-z]/)) {
      swal.fire({
        title: 'Password must include a lower case letter',
        timer: 2000,
        showConfirmButton: false,
        type: 'warning',
      });
      return;
    }

    if (this.newPassword.length < 8) {
      swal.fire({
        title: 'Password must be at least 8 characters long',
        timer: 2000,
        showConfirmButton: false,
        type: 'warning',
      });
      return;
    }

    this.authenticationService.setNewPassword(this.password, this.newPassword);
  }
}
